import { c as _c } from "react/compiler-runtime";
import type { AlertProps, IconNames } from '@petsmart-ui/sparky';
import { Alert, AlertBody, Heading, LayoutLinelengthContainer, TextPassage } from '@petsmart-ui/sparky';
import type { PropsWithChildren } from 'react';
export type AlertBannerProps = PropsWithChildren & {
  header?: string;
  iconName?: IconNames;
  variant?: AlertProps['variant'];
  className?: string;
  dismissible?: boolean;
};
export function AlertBanner(t0) {
  const $ = _c(15);
  const {
    header,
    iconName,
    variant: t1,
    className,
    children,
    dismissible
  } = t0;
  const variant = t1 === undefined ? "error" : t1;
  let t2;
  if ($[0] !== header) {
    t2 = header && <Heading tagName="h2" size="body-bold">{header}</Heading>;
    $[0] = header;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <LayoutLinelengthContainer>{t2}</LayoutLinelengthContainer>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <TextPassage>{children}</TextPassage>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <AlertBody>{t3}{t4}</AlertBody>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== className || $[10] !== dismissible || $[11] !== iconName || $[12] !== t5 || $[13] !== variant) {
    t6 = <Alert variant={variant} iconName={iconName} className={className} data-testid="alert-banner" dismissible={dismissible}>{t5}</Alert>;
    $[9] = className;
    $[10] = dismissible;
    $[11] = iconName;
    $[12] = t5;
    $[13] = variant;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}